<template>
  <div class="login-box">
    <div class="title">
      <div class="desc">手机账号登录</div>
      <div class="img" @click="changeLogin">
        <img
          src="https://imgheybox.max-c.com/oa/2023/02/08/fd777a7b3630248b8cf092dbc87979b1.png"
        />
      </div>
    </div>
    <div class="input-container">
      <div class="row">
        <div class="prefix">
          <label for="prefix">{{ list[index].split(' ')[1] }}<span></span></label>
          <select name="prefix" id="prefix" v-model="index">
            <option
              :value="index"
              :key="index"
              v-for="(country, index) in list"
            >
              {{ country }}
            </option>
          </select>
        </div>
        <input type="text" @input="handleInput" placeholder="请输入手机号码" v-model="account.value" />
      </div>
      <div class="input-item">
        <div class="row">
          <input
            type="text"
            placeholder="请输入验证码"
            maxlength="4"
            v-model="password.code"
          />
          <div class="btn-code" @click="getCode">
            <p :class="time < 61 || !account.value ? 'disable' : ''">
              {{ time == 61 ? '获取验证码' : `重新发送(${time}s)` }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="btn-container">
      <div class="btn login" @click="login" v-loading="loggingIn">登录</div>
    </div>
    <div class="bottom-bar">
      <div class="btn left-btn" @click="pwdLogin">
        <span>密码登录</span>
      </div>
      <div class="btn wechat-login" @click="wechatLogin">
        <IconBase width="20" height="20">
          <IconWechat />
        </IconBase>
        <span>微信登录</span>
      </div>
    </div>
    <transition name="fadeInOut">
      <div class="warning" v-text="warning" v-show="warning != ''"></div>
    </transition>
  </div>
</template>
<script>
import { sendCode, codeLogin } from '_api/account/login-v2';
import IconBase from './IconBase.vue';
import IconWechat from './IconWechat.vue';
import countries from '_lib/phone';

export default {
  props: {
    origin: {
      type: String,
      default: '',
    },
    account: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      password: {
        focus: false,
        value: '',
        cipherText: '',
        code: null,
      },
      loggingIn: false,
      warning: '',
      list: [],
      index: 0,
      time: 61,
    };
  },
  mounted() {
    window.addEventListener('keydown', this.onKeyDown);
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.onKeyDown);
  },
  created () {
    var list = []
    countries.forEach((cate, index) => {
      list = list.concat(cate.value)
    })
    this.list = list
  },
  methods: {
    handleInput(event) {
      this.$emit('update:phoneNumber', event.target.value); // 将输入值传递给父组件
    },
    onKeyDown(e) {
      if (e.keyCode == 13) {
        this.login();
      }
    },
    setCodeTime (time) {
      if (this.time == 0) {
        this.time = 61
      } else {
        this.time = time
        setTimeout(() => {
          this.setCodeTime(--time)
        }, 1000)
      }
    },
    //captcha验证
    getCode() {
      if (this.time < 61) {
        return
      }
      if (!this.account.value) {
        this.$message({
          message: '请填写手机号！',
          type: 'error',
        });
        return;
      }
      var query = {
        _notip: true,
      };

      if (this.randstr && this.ticket) {
        query.randstr = this.randstr;
        query.ticket = this.ticket;
        query.captcha_type = 'confirm';
        this.randstr = '';
        this.ticket = '';
      }
      var _this = this;

      var value = this.encrypt(this.list[this.index].split(' ')[1] + this.account.value);
      if (this.origin === 'wow') {
        value = this.account.value;
      }
      sendCode(query, {
        phone_num: value,
      })
        .then((res) => {
          if (res.data.status === 'ok') {
            let d = res.data.result;
            if (d.code) {
              this.$set(this.password, 'code', d.code);
            }
            this.setCodeTime(60);
          } else if (res.data.status == 'show_captcha') {
            var captcha = new TencentCaptcha('2061805035', function (q_res) {
              if (q_res.ret == 0) {
                _this.ticket = q_res.ticket;
                _this.randstr = q_res.randstr;
                _this.getCode();
              }
            });
            captcha.show();
          } else {
            this.$message({
              message: res.data.msg,
              type: 'error',
            });
          }
        })
        .catch((err) => {
          this.$message({
            message: '网络错误请稍后再试',
            type: 'error',
          });
        });
    },
    changeLogin() {
      this.isSent = false;
      this.password.value = '';
      this.password.code = null;
      clearInterval(this.time);
      this.$emit('changeLogin', 'qr');
    },
    pwdLogin() {
      this.$emit('changeLogin', 'pwd');
    },
    wechatLogin() {
      this.$emit('wechatLogin');
    },
    login() {
      if (this.loggingIn) {
        return;
      }
      if (this.account.value == '') {
        this.$message({
          message: '手机号码不能为空',
          type: 'error',
        });
        return;
      }

      this.loggingIn = true;

      this.account.cipherText = this.encrypt(this.list[this.index].split(' ')[1] + this.account.value);

      if (this.origin === 'wow') {
        this.account.cipherText = this.account.value;
      }
      const query = {
        code: this.password.code,
        web_source: 'open',
        _notip: true,
      };
      if (this.origin === 'wow') {
        query.client_type = 'wow_pc';
      }

      if (this.randstr && this.ticket) {
        query.randstr = this.randstr;
        query.ticket = this.ticket;
        query.captcha_type = 'confirm';
        this.randstr = '';
        this.ticket = '';
      }

      codeLogin(query, {
        phone_num: this.account.cipherText,
      })
        .then((res) => {
          this.loggingIn = false;
          if (res.data.status === 'ok') {
            this.$emit('setUserInfo', res);
          } else if (res.data.status == 'need_google_check') {
            this.$emit('googleVertify', res.data.result);
          } else if (res.data.status == 'show_captcha') {
            var _this = this;
            var captcha = new TencentCaptcha('2061805035', function (q_res) {
              if (q_res.ret == 0) {
                _this.ticket = q_res.ticket;
                _this.randstr = q_res.randstr;
                _this.login();
              }
            });
            captcha.show();
          } else {
            this.$message({
              message: res.data.msg,
              type: 'error',
            });
          }
        })
        .catch((res) => {
          this.loggingIn = false;
        });
    },
  },
  components: {
    IconWechat,
    IconBase,
  },
};
</script>
<style lang="less">
.login-box {
  position: relative;
  padding: 36px 45px 30px;
  @media (max-width: 450px) {
    padding: 0;
    width: 300px;
    margin: 0 auto;
  }
  .title {
    display: flex;
    align-items: center;
    color: #14191e;
    font-size: 20px;
    font-weight: 600;
    line-height: 28px;
    margin-bottom: 30px;
    .img {
      width: 38px;
      height: 38px;
      margin-left: auto;
      cursor: pointer;
      @media (max-width: 450px) {
        display: none;
      }
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .input-container {
    margin-bottom: 40px;
    .input-item {
      position: relative;
      &:not(:last-of-type) {
        margin-bottom: 30px;
      }
    }
  }
  .btn-container {
    .btn {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 44px;
      background: linear-gradient(to top, #464B50, #14191E) !important;
      border-radius: 4px;
      color: #fff;
      font-size: 16px;
      font-weight: 600;
      cursor: pointer;
      &::before {
        content: '';
        position: absolute;
        z-index: 1;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(#fff, 0.1);
        border-radius: 4px;
        opacity: 0;
        transition: 0.2s linear;
      }
      &:hover {
        &::before {
          opacity: 1;
        }
      }
      .el-loading-mask {
        background: #14191e;
        border-radius: 4px;
        .circular {
          width: 24px;
          .path {
            stroke: #fff;
          }
        }
      }
    }
    .el-button {
      height: 44px;
      margin-bottom: 10px;
      &.wechat-login {
        background: #07c160;
        border-color: #07c160;
        &:hover,
        &:focus {
          background: #07cf68;
          border-color: #07cf68;
        }
        .wechat-icon {
          width: 20px;
          vertical-align: middle;
          margin-right: 5px;
          + span {
            vertical-align: middle;
          }
        }
      }
    }
  }
  .bottom-bar {
    display: flex;
    margin-top: 20px;
    user-select: none;
    .btn {
      display: flex;
      align-items: center;
      color: #8c9196;
      font-size: 14px;
      font-weight: 500;
      margin-left: auto;
      cursor: pointer;
      &:hover {
        color: #14191e;
      }
      svg {
        margin-right: 6px;
        > g {
          transition: 0.2s linear;
        }
      }
      span {
        transition: 0.2s linear;
      }
    }
    .left-btn {
      margin-left: 0;
    }
    .change-login {
      margin-left: 0;
      margin-right: auto;
    }
  }
  .warning {
    position: absolute;
    left: 0;
    bottom: -40px;
    width: 100%;
    background: #f56c6c;
    border-radius: 4px;
    color: #fff;
    font-size: 13px;
    line-height: 30px;
    margin-top: 10px;
    padding-left: 15px;
  }
}
.row {
  width: 100%;
  height: 58px;
  padding: 18px 0 2px;
  display: flex;
  position: relative;
  margin-bottom: 30px;
  border-bottom: 2px solid #e9ecf0;
  align-items: center;
  &:after {
    content: '';
    width: 100%;
    height: 1px;
    background-color: #f1f2f3;
    position: absolute;
    bottom: 0;
    left: 0;
    transform: scaleY(0.5);
  }
  .btn-code {
    width: 86px;
    height: 30px;
    margin-left: 12px;
    p {
      width: 100%;
      height: 30px;
      line-height: 30px;
      font-size: 12px;
      color: #14191e;
      background-color: #f7f8f9;
      text-align: center;
      border-radius: 2px;
      &.disable {
        background-color: #f7f8f9;
        color: #c8cdd2;
      }
    }
  }
  input {
    flex: 1;
    width: 0;
    overflow: hidden;
    position: relative;
    z-index: 2;
    height: 40px;
    line-height: 30px;
    font-size: 15px;
    color: #14191e;
    width: 100vw;
    border: none !important;
  }
  .prefix {
    position: relative;
    min-width: 66px;
    padding-right: 12px;
    label {
      height: 30px;
      font-size: 15px;
      color: #14191e;
      font-weight: 600;
      display: flex;
      align-items: center;
      span {
        display: inline-block;
        width: 0;
        height: 0;
        border-top: 6px solid #14191e;
        border-bottom: none;
        border-left: 5px solid rgba(0, 0, 0, 0);
        border-right: 5px solid rgba(0, 0, 0, 0);
        margin: 3px 0 0 2px;
      }
    }
    select {
      opacity: 0;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
    }
  }
}
.row:focus-within {
  border-bottom: 2px solid #14191e; /* 设置为你需要的颜色 */
}
&::-webkit-input-placeholder {
  color: #c8cdd2 !important;
  font-size: 15px;
}
</style>